let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hh98W")).then(() => parcelRequire('jPybt'));